import type { Query, QuerySearchV2Args } from '@ab-core/graphql/dist';
import { useQuery } from '@apollo/client';
import { useEffect, useState } from 'react';
import { getErrorLoggerFunction } from '../utils';
import { GET_CABLE_SNAPS } from './gql/getCableSnaps';
import { searchV2DataMapper } from './productSearchMapper';

type QueryDataType = Pick<Query, 'searchV2'>;
type QueryArgs = QuerySearchV2Args;
type OutgoingDataType = QueryDataType['searchV2'];

type IncomingDataType = {
    search?: string;
    page?: number;
    skip?: boolean;
};

const onError = getErrorLoggerFunction('searchV2-cableSnap');

export const useCableSnaps = (props: IncomingDataType) => {
    const { search, page = 1, skip = false } = props;
    const [outgoingData, setOutgoingData] = useState<OutgoingDataType>(undefined);

    const query = `?query=${search ? search : '*'}&filter=hasCableSnap:true&page=${page}`;

    const { data, loading, refetch, error } = useQuery<QueryDataType, QueryArgs>(GET_CABLE_SNAPS, {
        variables: {
            query
        },
        skip,
        onError
    });

    useEffect(() => {
        if (data?.searchV2) {
            const mappedData = searchV2DataMapper(data?.searchV2);
            setOutgoingData(mappedData);
        }
    }, [data]);

    return {
        cableSnaps: outgoingData,
        error: !!error,
        success: !!data,
        loading,
        refetch
    };
};
